import React from "react";
import "../styles/Footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* ✅ Left Section - Branding & Quote */}
        <div className="footer-brand">
          <img src="/Homelogo (7).jpg" alt="ChronicTrace Logo" className="footer-logo" />
          <p className="brand-quote">
            "The Future of Concussion Awareness"
          </p>
        </div>

        {/* ✅ Middle Section - Quick Navigation */}
        <div className="footer-links">
          <h3>Explore</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/blog">Blog</Link></li>
          </ul>
        </div>

        {/* ✅ Right Section - Contact & AI Future */}
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p><i className="fa-solid fa-envelope"></i> <a href="mailto:info@chronictrace.com">justinbordner@chronictrace.com</a></p>
          <p><i className="fa-solid fa-phone"></i> <a href="tel:+17176143681">+1 (717) 614-3681</a></p>
          <p><i className="fa-solid fa-map-marker-alt"></i> ChronicTrace HQ, USA</p>
        </div>
      </div>

      {/* ✅ Bottom Section */}
      <div className="footer-bottom">
        <p>© 2025 ChronicTrace. All Rights Reserved. | Powered by AI & Blockchain</p>
      </div>
    </footer>
  );
}

export default Footer;